import { render } from "./PresentationFileUploadForm.vue?vue&type=template&id=15c41a5e"
import script from "./PresentationFileUploadForm.vue?vue&type=script&lang=js"
export * from "./PresentationFileUploadForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__